module.exports = __webpack_public_path__ + "static/media/close-icon-big.629a8c47.svg";